import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	badge: {
		right: 8,
		top: 8,
		padding: "4px",
		borderRadius: "4px",
		fontSize: "10px",
		fontWeight: 600,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[400])
	}
}))

export default useStyles
